import { useState } from 'react';

import { basicMsg } from '../../../actions/swal_msg';

import {
    Box, Collapse, Divider, Grid, IconButton, Stack,
    Typography, Alert, LinearProgress, useMediaQuery
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { GOOGLE_DRIVE_CDN } from '../../../constants/constants';
import { buildGoogleMapsEmbedUrl } from '../../../helpers/admin/branch/googleMaps';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

const BranchList = ({
    initialLoading, branches,
    orderedBranches, setOrderedBranches,
    setAnchorEl, setActiveBranch
}) => {
    const matches = useMediaQuery('(max-width: 575px)');

    //Collapse
    const [collapse, setCollapse] = useState({});
    const toggleCollapsable = (id) => () => {
        setCollapse((set) => ({
            ...set,
            [id]: !set[id]
        }));
    };

    const handleClick = (id) => (event) => {
        const Branch = orderedBranches.find(e => e._id === id);
        if (Branch) {
            const {
                _id, title: name, phone, email,
                address: { street, colony, postalcode, city, state },
                links: { whatsapp, facebook, googleMaps = {} }, folderId, imgId
            } = Branch;
            setActiveBranch((e) => ({
                ...e, _id, folderId, imgId,
                name, phone, email, address: street,
                postalCode: postalcode, colony, city, state,
                links: { whatsapp, facebook, google_maps: { ...googleMaps } }
            }));
            setAnchorEl(event.currentTarget);
        } else basicMsg('No se encontró la sucursal');
    };

    const handleMove = (index, direction) => () => {
        // usar el "Functional Update" para asegurar el estado más reciente
        setOrderedBranches((currentList) => {
            return reorderBranch(currentList, index, direction);
        });
    };

    const reorderBranch = (list, index, direction) => {
        const newArray = [...list];
        const newIndex = direction === 'up' ? index - 1 : index + 1;

        // verificar posición en arreglo
        if (newIndex < 0 || newIndex >= newArray.length) return list;

        // intercambio usando desestructuración
        [newArray[index], newArray[newIndex]] = [newArray[newIndex], newArray[index]];

        return newArray;
    };

    const MoreIcon = matches ? MoreHorizIcon : MoreVertIcon;
    
    return (
        <Stack spacing={2}>
            {
                initialLoading ?
                    <>
                        <Alert severity="info">
                            Cargando sucursales...
                        </Alert>
                        <LinearProgress color="info" />
                    </>
                :
                orderedBranches.length > 0 ?
                    orderedBranches.map(({
                        _id, imgId, title, phone, email,
                        address: { street, colony, postalcode, city, state },
                        links: {
                            whatsapp: { number },
                            googleMaps = {}
                        }
                    }, index) => {
                        const KeyboardIcon = collapse[_id] ? KeyboardArrowUpIcon : KeyboardArrowDownIcon;
                        const embedUrl = buildGoogleMapsEmbedUrl(googleMaps, GOOGLE_MAPS_API_KEY);
                        return (
                            <Box key={ _id } className='box_branches' p={3}>
                                <Grid container spacing={3}>
                                    <Grid item xl={6.5} lg={6.5} md={8} sm={12} xs={12}
                                        order={{ xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}>
                                        <Box className='flex_branches'>
                                            <Box sx={{ my: 'auto' }}>
                                                <img src={`${GOOGLE_DRIVE_CDN}${imgId}`}
                                                    alt='imagen-sucursal' className='img_branches'
                                                />
                                            </Box>
                                            <Box sx={{ my: 'auto' }}>
                                                <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
                                                    { title }
                                                </Typography>
                                                <Typography variant='body2' color='text.secondary'>
                                                    { street } C.P. { postalcode }
                                                </Typography>
                                                <Typography variant='body2' color='text.secondary'>
                                                    Col. { colony }, { city }, { state }
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>

                                    <Grid item xl={3.5} lg={3.5} md={12} sm={6} xs={12}
                                        order={{ xl: 2, lg: 2, md: 3, sm: 2, xs: 2 }} sx={{ my: 'auto' }}>
                                        <Box className='info_flex_branches'>
                                            <PhoneIcon fontSize="inherit" />
                                            <Typography variant="body2">{ phone }</Typography>
                                        </Box>
                                        <Box className='info_flex_branches'>
                                            <SmartphoneIcon fontSize="inherit" />
                                            <Typography variant="body2">{ number }</Typography>
                                        </Box>
                                        <Box className='info_flex_branches'>
                                            <EmailIcon fontSize="inherit" />
                                            <Typography variant="body2">{ email }</Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xl={2} lg={2} md={4} sm={6} xs={12}
                                        order={{ xl: 3, lg: 3, md: 2, sm: 3, xs: 3 }}
                                        sx={{ my: 'auto' }}>
                                        <Stack spacing={1} direction="row"
                                            justifyContent={ matches ? 'center' : 'flex-end' }
                                            alignItems="center">
                                            {
                                                index !== 0 &&
                                                    <IconButton onClick={ handleMove(index, 'up') }
                                                        color="primary">
                                                        <ArrowUpwardIcon />
                                                    </IconButton>
                                            }
                                            {
                                                index !== orderedBranches.length - 1 &&
                                                    <IconButton onClick={ handleMove(index, 'down') }
                                                        color="primary">
                                                        <ArrowDownwardIcon />
                                                    </IconButton>
                                            }
                                            
                                            <IconButton onClick={ toggleCollapsable(_id) }>
                                                <KeyboardIcon />
                                            </IconButton>
                                            <IconButton onClick={ handleClick(_id) }>
                                                <MoreIcon />
                                            </IconButton>
                                        </Stack>
                                    </Grid>
                                </Grid>

                                <Collapse in={collapse[_id]} timeout='auto' unmountOnExit>
                                <Divider sx={{ my: 3 }} />
                                <Grid container spacing={4}>
                                    <Grid item xl={6} lg={8} md={12} sm={12} xs={12}>
                                        {embedUrl ? (
                                            <iframe
                                                src={embedUrl}
                                                width="100%"
                                                height="450"
                                                title={`Mapa de ${title}`}
                                                style={{ border: '0', borderRadius: '10px' }}
                                                allowFullScreen=""
                                                loading="lazy"
                                                referrerPolicy="no-referrer-when-downgrade"
                                            />
                                        ) : (
                                            <Alert severity="warning">
                                                Esta sucursal todavía no tiene una ubicación de Google Maps configurada.
                                            </Alert>
                                        )}
                                    </Grid>
                                </Grid>
                                </Collapse>
                            </Box>
                        )
                    })
                :
                    <Alert icon={<InfoIcon fontSize="inherit" />} severity="info">
                        Sin sucursales
                    </Alert>
            }
        </Stack>
    );
};

export default BranchList;
